import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  FaSearch, 
  FaInfoCircle, 
  FaBuilding, 
  FaArrowRight, 
  FaShieldAlt, 
  FaLeaf, 
  FaCogs, 
  FaUserShield, 
  FaGavel,
  FaChevronLeft,
  FaChevronRight
} from "react-icons/fa";
import "../Style/Certifications.css"; 
import heroMarineImage from "../assets/Gemini_Generated_Image_9rta349rta349rta.png";
import heroFoodImage from "../assets/food saftey.png";

function Certifications() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSector, setSelectedSector] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 9; // 3 rows * 3 cards per row

  const frameworks = [
    { 
      title: "ISO 9001:2015", 
      name: "Quality Management System (QMS)", 
      purpose: "Improves product and service quality and customer satisfaction.", 
      industries: "Resorts, Hotels, Construction, Manufacturing, Government", 
      category: "Operations", 
      id: "iso-9001", 
      image: "https://plus.unsplash.com/premium_photo-1664475185887-ada9f6f59342?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fHw%3D" 
    },
    { 
      title: "ISO 14001:2015", 
      name: "Environmental Management System (EMS)", 
      purpose: "Controls environmental impacts and pollution.", 
      industries: "Resorts, Marine, Fisheries, Construction", 
      category: "Sustainability", 
      id: "iso-14001", 
      image: "https://media.istockphoto.com/id/1393825226/photo/esg-banner-environment-society-and-corporate-governance-the-information-banner-calls-to.jpg?s=612x612&w=0&k=20&c=rxdDyrzZtmYj4OzTE3rMTItwTiNNx3DJr52vXXnjK98=" 
    },
    { 
      title: "ISO 45001:2018", 
      name: "Occupational Health & Safety Management System", 
      purpose: "Protects employees from workplace hazards.", 
      industries: "Construction, Marine, Healthcare, Tourism", 
      category: "Safety", 
      id: "iso-45001", 
      image: "https://media.istockphoto.com/id/1334574093/photo/male-industrial-electrical-engineer-with-helmet-and-blueprints-in-hands-checking-maintenance.webp?a=1&b=1&s=612x612&w=0&k=20&c=yHDTXtT_0EVKEft9vAvcrnbqChp3s_V7-Tg6jK24pMs=" 
    },
    { 
      title: "ISO/IEC 27001:2022", 
      name: "Information Security Management System (ISMS)", 
      purpose: "Protects confidential information and cybersecurity.", 
      industries: "IT Companies, Banks, Government, Healthcare", 
      category: "Security", 
      id: "iso-27001", 
      image: "https://plus.unsplash.com/premium_photo-1733317239304-a6bf462a2596?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8SVNPJTIwMjcwMDElMjBJbmZvcm1hdGlvbiUyMFNlY3VyaXR5JTIwTWFuYWdlbWVudHxlbnwwfHwwfHx8MA%3D%3D" 
    },
    { 
      title: "ISO 22000:2018", 
      name: "Food Safety Management System", 
      purpose: "Ensures food safety across the supply chain.", 
      industries: "Hotels, Restaurants, Fisheries, Food Processing", 
      category: "Safety", 
      id: "iso-22000", 
      image: "https://media.istockphoto.com/id/1161610414/photo/technologist-expert-in-protective-uniform-with-hairnet-and-mask-taking-parameters-from.webp?a=1&b=1&s=612x612&w=0&k=20&c=D3g927DKkoU-i0PvqwfeX6dpcsKI9Sl9CelD0pFK6Lc=" 
    },
    { 
      title: "HACCP Certification", 
      name: "Hazard Analysis & Critical Control Points", 
      purpose: "Identifies and monitors biological, chemical, and physical food hazards.", 
      industries: "Resorts, Commercial Kitchens, Seafood Processing, Catering", 
      category: "Safety", 
      id: "haccp", 
      image: "https://media.istockphoto.com/id/1159025115/photo/haccp-alphabet-and-acronym.jpg?s=612x612&w=0&k=20&c=3xH_SVMWmSVP5BsHgA4OcnWmoVX41kuG50iJVUMKjA8=" 
    },
    { 
      title: "FSSC 22000", 
      name: "Food Safety System Certification", 
      purpose: "GFSI-recognized benchmark standard for food manufacturers.", 
      industries: "Seafood Exporters, Food Processing Plants, Beverage Bottling", 
      category: "Safety", 
      id: "fssc-22000", 
      image: "https://images.unsplash.com/photo-1754372069872-3fef8a815c87?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fEZTU0MlMjAyMjAwMCUyMEZvb2QlMjBTYWZldHklMjBTeXN0ZW0lMjBDZXJ0aWZpY2F0aW9ufGVufDB8fDB8fHww" 
    },
    { 
      title: "GMP", 
      name: "Good Manufacturing Practices", 
      purpose: "Ensures products are consistently produced according to quality standards.", 
      industries: "Pharmaceuticals, Cosmetics, Food Processing, Seafood", 
      category: "Operations", 
      id: "gmp", 
      image: "https://plus.unsplash.com/premium_photo-1661962239963-2fd78727f62d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fEdNUCUyMEdvb2QlMjBNYW51ZmFjdHVyaW5nJTIwUHJhY3RpY2VzfGVufDB8fDB8fHww" 
    },
    { 
      title: "GHP", 
      name: "Good Hygiene Practices", 
      purpose: "Establishes essential sanitary conditions for handling human consumables.", 
      industries: "Hotels, Catering, Food Retail, Bakeries, Water Bottling", 
      category: "Safety", 
      id: "ghp", 
      image: "https://plus.unsplash.com/premium_photo-1661662860714-7ea91a565bf9?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fEdIUCUyMEdvb2QlMjBIeWdpZW5lJTIwUHJhY3RpY2VzfGVufDB8fDB8fHww" 
    },
    { 
      title: "BRCGS", 
      name: "Global Standard for Food Safety", 
      purpose: "International trade standard required by European and global food retailers.", 
      industries: "Seafood Exporters, Food Manufacturers, Packaging Plants", 
      category: "Safety", 
      id: "brcgs", 
      image: "https://media.istockphoto.com/id/1365998555/photo/fresh-seafood-arrangement-on-dark-background.webp?a=1&b=1&s=612x612&w=0&k=20&c=vhuE7qrOqgbWxfevcmt36N5XtYVvLUaeffxBQdpdJ6Q=" 
    },
    { 
      title: "MSC Chain of Custody", 
      name: "Marine Stewardship Council Traceability", 
      purpose: "Ensures sustainable seafood traceability from certified fisheries to buyers.", 
      industries: "Fisheries, Seafood Processors, Exporters, Resort Dining", 
      category: "Sustainability", 
      id: "msc-coc", 
      image: "https://images.unsplash.com/photo-1691104997466-f207cf77e9ca?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fE1TQyUyMENoYWluJTIwb2YlMjBDdXN0b2R5JTIwTWFyaW5lJTIwU3Rld2FyZHNoaXAlMjBDb3VuY2lsJTIwVHJhY2VhYmlsaXR5fGVufDB8fDB8fHww" 
    },
    { 
      title: "Halal Certification", 
      name: "Halal Assurance System", 
      purpose: "Verifies products meet Islamic sharia rules for consumption and handling.", 
      industries: "Food Processing, Resorts, Cosmetics, Logistics", 
      category: "Governance", 
      id: "halal", 
      image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 50001:2018", 
      name: "Energy Management System", 
      purpose: "Improves energy efficiency and reduces energy costs.", 
      industries: "Resorts, Manufacturing, Utilities", 
      category: "Sustainability", 
      id: "iso-50001", 
      image: "https://plus.unsplash.com/premium_photo-1726837539328-cf297292b6cc?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fElTTyUyMDkwMDElMjBRdWFsaXR5JTIwTWFuYWdlbWVudCUyMFN5c3RlbXxlbnwwfHwwfHx8MA%3D%3D" 
    },
    { 
      title: "ISO 22301:2019", 
      name: "Business Continuity Management System", 
      purpose: "Ensures business continuity during disruptions.", 
      industries: "Banks, Telecom, IT, Government", 
      category: "Security", 
      id: "iso-22301", 
      image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 13485:2016", 
      name: "Medical Devices Quality Management", 
      purpose: "Quality management for medical device manufacturers.", 
      industries: "Healthcare and Medical Equipment", 
      category: "Operations", 
      id: "iso-13485", 
      image: "https://images.unsplash.com/photo-1584515979956-d9f6e5d09982?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 15189", 
      name: "Medical Laboratories Requirements", 
      purpose: "Validates diagnostic accuracy and quality in medical testing labs.", 
      industries: "Hospital Diagnostic Labs, Pathology Clinics, Research Centers", 
      category: "Operations", 
      id: "iso-15189", 
      image: "https://www.who.int/images/default-source/searo---images/countries/maldives/mhqs.jpg?sfvrsn=12b0cd78_1" 
    },
    { 
      title: "NABH Consultancy", 
      name: "Hospital Healthcare Standards", 
      purpose: "Hospital quality benchmarks for patient safety and clinical governance.", 
      industries: "Hospitals, Specialty Clinics, Healthcare Centers", 
      category: "Safety", 
      id: "nabh-consultancy", 
      image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 20000-1:2018", 
      name: "IT Service Management", 
      purpose: "Improves IT service delivery.", 
      industries: "IT Service Providers", 
      category: "Operations", 
      id: "iso-20000-1", 
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 37001:2016", 
      name: "Anti-Bribery Management System", 
      purpose: "Prevents bribery and corruption.", 
      industries: "Government, Financial Services, Large Enterprises", 
      category: "Governance", 
      id: "iso-37001", 
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR53hhVzArF86kG8FMdzOOpyR7j5bL_oRqkJ3XMuPjEHA&s=10" 
    },
    { 
      title: "ISO 31000", 
      name: "Risk Management Guidelines", 
      purpose: "Enterprise risk management guidelines.", 
      industries: "All industries", 
      category: "Governance", 
      id: "iso-31000", 
      image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 21001:2018", 
      name: "Educational Organization Management", 
      purpose: "Improves education quality.", 
      industries: "Schools, Colleges, Training Institutes", 
      category: "Operations", 
      id: "iso-21001", 
      image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 55001:2014", 
      name: "Asset Management System", 
      purpose: "Efficient management of physical assets.", 
      industries: "Utilities, Infrastructure, Airports", 
      category: "Operations", 
      id: "iso-55001", 
      image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 39001:2012", 
      name: "Road Traffic Safety Management", 
      purpose: "Reduces road traffic risks.", 
      industries: "Transport and Logistics", 
      category: "Safety", 
      id: "iso-39001", 
      image: "https://corporatemaldives.com/wp-content/uploads/2024/07/Ziam-2024-07-28T150802.724.png" 
    },
    { 
      title: "ISO 26000", 
      name: "Social Responsibility Guidance", 
      purpose: "Corporate social responsibility guidance.", 
      industries: "All organizations", 
      category: "Governance", 
      id: "iso-26000", 
      image: "https://enqafm7df2v.exactdn.com/wp-content/uploads/2023/02/Feature-Culture-and-traditions.jpg?strip=all" 
    },
    { 
      title: "ISO 28000:2022", 
      name: "Supply Chain Security Management", 
      purpose: "Secures logistics and supply chains.", 
      industries: "Shipping, Ports, Logistics", 
      category: "Security", 
      id: "iso-28000", 
      image: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 41001:2018", 
      name: "Facility Management System", 
      purpose: "Improves facility operations.", 
      industries: "Hotels, Hospitals, Commercial Buildings", 
      category: "Operations", 
      id: "iso-41001", 
      image: "http://blog.maldivescomplete.com/wp-content/uploads/2024/01/Cora-Cora-uniforms.jpg" 
    },
    { 
      title: "ISO 20121:2024", 
      name: "Sustainable Event Management", 
      purpose: "Sustainable event planning.", 
      industries: "Tourism and Events", 
      category: "Sustainability", 
      id: "iso-20121", 
      image: "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 10002:2018", 
      name: "Customer Complaint Management", 
      purpose: "Handles customer complaints effectively.", 
      industries: "Service Organizations", 
      category: "Governance", 
      id: "iso-10002", 
      image: "https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=600&q=80" 
    },
    { 
      title: "ISO 10001:2018", 
      name: "Customer Satisfaction Codes of Conduct", 
      purpose: "Improves customer trust.", 
      industries: "Hospitality, Retail", 
      category: "Governance", 
      id: "iso-10001", 
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhSW3W9NQb_YGKga_0Yi56-G42LAwuV1xFCRbaMg4vpg&s=10" 
    }
  ];

  const categories = ["All", "Operations", "Sustainability", "Safety", "Security", "Governance"];

  const getCategoryIcon = (category) => {
    switch(category) {
      case "Operations": return <FaCogs />;
      case "Sustainability": return <FaLeaf />;
      case "Safety": return <FaShieldAlt />;
      case "Security": return <FaUserShield />;
      case "Governance": return <FaGavel />;
      default: return <FaBuilding />;
    }
  };

  const filteredFrameworks = frameworks.filter((item) => {
    const titleStr = item.title || "";
    const nameStr = item.name || "";
    const industryStr = item.industries || "";
    const catStr = item.category || "Default";

    const matchesSearch = 
      titleStr.toLowerCase().includes(searchTerm.toLowerCase()) ||
      nameStr.toLowerCase().includes(searchTerm.toLowerCase()) ||
      industryStr.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesCategory = selectedSector === "All" || catStr === selectedSector;
    
    return matchesSearch && matchesCategory;
  });

  // Pagination Calculations
  const totalPages = Math.ceil(filteredFrameworks.length / cardsPerPage);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = filteredFrameworks.slice(indexOfFirstCard, indexOfLastCard);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 400, behavior: "smooth" });
  };

  const handleCategoryChange = (cat) => {
    setSelectedSector(cat);
    setCurrentPage(1); // Reset to page 1 on filter change
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to page 1 on search query change
  };

  return (
    <div className="compliance-matrix-layout">
      {/* Light Topological Ocean Background Mask */}
      <div className="maldives-topo-bg">
        <div className="ocean-blur-orb orb-1"></div>
        <div className="ocean-blur-orb orb-2"></div>
      </div>

      <header className="matrix-header">
        <div
          className="hero-marine-image-canvas"
          style={{
            backgroundImage: `url(${heroMarineImage})`,
          }}
        ></div>
        
        <div className="matrix-container header-split">
          <div className="header-text-content">
            <span className="matrix-badge">Maldives Engine Active</span>
            <h1>Available ISO Certifications & Standards</h1>
            <p>
              Cross-reference and verify international standard structures validated for 
              Maldivian commercial operations, luxury resort hospitality, and maritime logistics.
            </p>
          </div>
          
          <div className="header-visual-showcase">
            <div className="maldives-cluster-grid">
              <div className="showcase-frame frame-primary shadow-effect">
                <img 
                  src={heroFoodImage} 
                  alt="Maldives Overwater Luxury Resort" 
                  className="hero-display-img"
                />
              </div>
              <div className="showcase-frame frame-secondary shadow-effect">
                <img 
                  src="https://media.istockphoto.com/id/1061166684/photo/environment-earth-day-in-the-hands-of-trees-growing-seedlings-bokeh-green-background-female.webp?a=1&b=1&s=612x612&w=0&k=20&c=U8VjObE33GTX4aPfvRIFmgLUqJQT3V-GZZ-dtd4ORKU=" 
                  alt="Maldives Transparent Lagoon" 
                  className="hero-display-img-secondary"
                />
                <div className="showcase-glass-badge">
                  <FaLeaf className="badge-nature-icon" />
                  <span>Eco-Certified Resorts</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="matrix-controls-panel">
        <div className="matrix-container control-flex">
          <div className="search-wrapper">
            <input 
              type="text" 
              placeholder="Search by code, keyword, or island sector..." 
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <FaSearch className="search-icon" />
          </div>

          <div className="filter-tab-row">
            {categories.map((cat) => (
              <button 
                key={cat}
                className={`filter-tab-btn ${selectedSector === cat ? "active" : ""}`}
                onClick={() => handleCategoryChange(cat)}
              >
                <span className="btn-icon-spacer">{cat !== "All" && getCategoryIcon(cat)}</span>
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      <main className="matrix-container grid-view-section">
        <div className="cards-display-grid">
          {currentCards.length > 0 ? (
            currentCards.map((item, index) => (
              <div 
                key={item.id} 
                className={`compliance-portal-card border-accent-${(item.category || "default").toLowerCase()}`}
                style={{ "--card-index": index }}
                onClick={() => navigate(`/certifications/${item.id}`)}
              >
                <div className="card-image-wrapper">
                  <img src={item.image} alt={item.title} className="card-primary-bg" />
                  <div className="card-image-overlay"></div>
                  <span className={`card-category-tag tag-${(item.category || "default").toLowerCase()}`}>
                    {getCategoryIcon(item.category)} {item.category}
                  </span>
                </div>

                <div className="card-content-body">
                  <div className="card-meta-header">
                    <span className="card-ref-code">{item.title}</span>
                  </div>
                  <h3 className="card-title-heading">{item.name}</h3>
                  <p className="card-purpose-desc">{item.purpose}</p>
                  
                  <div className="card-divider"></div>

                  <div className="card-industry-info">
                    <FaBuilding className="building-node-icon" />
                    <span className="industry-text-nodes">{item.industries}</span>
                  </div>

                  <div className="card-action-trigger">
                    <span className="trigger-text">Analyze Protocol</span>
                    <div className="trigger-arrow-circle">
                      <FaArrowRight />
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="matrix-empty-state-card">
              <FaInfoCircle className="empty-state-icon" />
              <h3>No Matching Protocols Located</h3>
              <p>Refine your structural query terms or switch the operational sector classification tab.</p>
            </div>
          )}
        </div>

        {/* Pagination Navigation Bar */}
        {totalPages > 1 && (
          <div className="pagination-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '40px', marginBottom: '20px' }}>
            <button 
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
              className="pagination-btn-nav"
              style={{ padding: '10px 16px', background: currentPage === 1 ? '#e2e8f0' : '#0f172a', color: currentPage === 1 ? '#94a3b8' : '#ffffff', border: 'none', borderRadius: '6px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600' }}
            >
              <FaChevronLeft /> Prev
            </button>

            {[...Array(totalPages)].map((_, idx) => {
              const pageNum = idx + 1;
              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  style={{
                    padding: '10px 14px',
                    background: currentPage === pageNum ? '#0284c7' : '#f8fafc',
                    color: currentPage === pageNum ? '#ffffff' : '#0f172a',
                    border: '1px solid #cbd5e1',
                    borderRadius: '6px',
                    fontWeight: '700',
                    cursor: 'pointer'
                  }}
                >
                  {pageNum}
                </button>
              );
            })}

            <button 
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
              className="pagination-btn-nav"
              style={{ padding: '10px 16px', background: currentPage === totalPages ? '#e2e8f0' : '#0f172a', color: currentPage === totalPages ? '#94a3b8' : '#ffffff', border: 'none', borderRadius: '6px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600' }}
            >
              Next <FaChevronRight />
            </button>
          </div>
        )}
      </main>

      <footer className="matrix-process-footer">
        <div className="matrix-container grid-3-col">
          <div className="process-card-flat">
            <div className="p-num">01</div>
            <h4>Gap Assessment</h4>
            <p>System mapping against corporate or resort documentation profiles.</p>
          </div>
          <div className="process-card-flat">
            <div className="p-num">02</div>
            <h4>Manual Integration</h4>
            <p>Developing operational SOPs explicitly ready for registrar checking.</p>
          </div>
          <div className="process-card-flat">
            <div className="p-num">03</div>
            <h4>Audit Execution</h4>
            <p>Complete onsite support during final external assessor validation cycles.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Certifications;